import { render, staticRenderFns } from "./FormControlTypeDateDate.vue?vue&type=template&id=6d151fca&scoped=true"
import script from "./FormControlTypeDateDate.vue?vue&type=script&lang=js"
export * from "./FormControlTypeDateDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d151fca",
  null
  
)

export default component.exports